import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';

import * as _ from 'underscore';
import { LocalStorageService } from '../../../common';
import { AuthService } from '../../../services/auth.service';
import { DashboardService } from '../dashboard.service';
import { DashboardItemColumn, DashboardItemDescriptor, DashboardItemFilter, DashboardItemFilterType, DashboardItemType } from '../model/dashboard.item';

@Component({
  selector: 'app-dashboard-container',
  styleUrls: ['./container.component.sass'],
  templateUrl: './container.component.pug'
})
export class DashboardContainerComponent implements OnInit, OnDestroy {
private readonly DASHBOARD_CONFIG: string = "Dashboard";

public isAuthorizedSubscription: Subscription;

config: any;
dashboardItems: DashboardItemDescriptor[];

  constructor(
    private service: DashboardService,
    private authService: AuthService,
    private localStorage: LocalStorageService,
  ) {
    this.config = localStorage.get(this.DASHBOARD_CONFIG) || { dashboardVisible: true };
  }

  public ngOnInit(): void {
   this.isAuthorizedSubscription = this.authService.getIsAuthorized().subscribe(
      (isAuthorized: boolean) => {
        if (!isAuthorized) {
           setInterval(() => {
              if (!this.dashboardItems) {
                this.service.getDashboardItems().then(dashboardItems => {
                  this.dashboardItems = dashboardItems;
                });      
              }
           }, 1000);
        }
        else {
          this.service.getDashboardItems().then(dashboardItems => {
            this.dashboardItems = dashboardItems;
          });
        }
      });
  }

  ngOnDestroy(): void {
    this.isAuthorizedSubscription.unsubscribe();
  }

  showHideDashboard(): void {
    this.config.dashboardVisible = !this.config.dashboardVisible;
    this.localStorage.set(this.DASHBOARD_CONFIG, this.config);
  }

  saveFilters(): void {
    this.localStorage.set(this.DASHBOARD_CONFIG, this.config);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/container/container.component.ts